<template>
  <div>
    <v-content app>
      <!--<div>WEBSOCKETS: {{ wsData }}</div>-->
      <v-container fluid fill-height>
        <v-layout class="mt-5" justify-center v-if="is_loading">
          <spinner
            :status="is_loading"
            :size="50"
            :depth="3"
            color="#0033A0"
            :speed="1.4"
            :clockwise="true"></spinner>
        </v-layout>

        <v-layout justify-center v-if="!is_loading">
          <template>
            <v-layout>
              <v-flex sm12>
                <v-layout>
                  <v-flex sm12>
                    <v-breadcrumbs class="pb-1" icons divider=">">
                      <v-breadcrumbs-item>
                        <div class="text-uppercase">HOME</div>
                      </v-breadcrumbs-item>
                      <v-breadcrumbs-item>
                        <div class="text-uppercase">{{ $route.params.workspace_name }}</div>
                      </v-breadcrumbs-item>
                      <v-breadcrumbs-item>
                        {{ $route.params.app_name }}
                      </v-breadcrumbs-item>
                      <v-breadcrumbs-item class="active-run--breadcrumb">
                        <strong>{{ current_active_run.name }}</strong>
                      </v-breadcrumbs-item>
                    </v-breadcrumbs>
                  </v-flex>
                </v-layout>
                <v-card class="mr-3">
                  <v-layout align-baseline>
                    <v-flex sm6>
                      <v-card-title class="pb-1">
                        <div class="flex-it align-items-center">
                          <h3 class="headline mb-0">{{ $route.params.app_name }}</h3>
                        </div>
                      </v-card-title>
                    </v-flex>
                    <v-flex sm6>
                      <div v-if="$route.params.workspace_name === 'Cabelte'" class="app-logo--wrapper">
                        <img class="logo-style app-logo--size" src="../assets/app_logos/cabelte_logo.png">
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout align-baseline class="mb-10">
                    <v-flex class="hidden-xs-only" xs12 sm12 md6 lg6>
                      <v-card-title class="pt-0">
                        <v-btn-toggle class="filter-button--wrapper" v-model="active_status" multiple>
                          <v-btn class="filter-button text-lowercase" v-for="state in status" flat :value="state.status"
                                 :key="state.id">
                            <v-chip outline class="pointer" :color="state.color">{{ state.status }}</v-chip>
                          </v-btn>
                        </v-btn-toggle>
                      </v-card-title>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                      <v-text-field
                        class="pr-3 ml-3"
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-data-table
                    expand
                    must-sort
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    :loading="loadingDataTable"
                    :headers="headers"
                    :items="filteredRuns"
                    :search="search"
                    class="elevation-2"
                  >
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <tr @click="run_injection(props.item)"
                          :class="{current:props.item.id == current}">
                        <td>{{ props.item.id }}</td>
                        <td class="text-xsleftr">{{ props.item.name }}</td>
                        <td class="text-xs-left">{{ props.item.create_date }} ({{ props.item.create_hour }})</td>
                        <td class="text-xs-left">
                          <v-chip v-if="props.item.status === 'success'" outline color="green">{{
                              props.item.status
                            }}
                          </v-chip>
                          <v-chip v-if="props.item.status === 'running'" outline color="blue">{{
                              props.item.status
                            }}
                          </v-chip>
                          <v-chip v-if="props.item.status === 'pending'" outline color="amber">{{
                              props.item.status
                            }}
                          </v-chip>
                          <v-chip v-if="props.item.status === 'error'" outline color="red">{{
                              props.item.status
                            }}
                          </v-chip>
                          <v-chip v-if="props.item.status === 'canceled'" outline color="gray">{{
                              props.item.status
                            }}
                          </v-chip>
                        </td>
                        <td class="text-xs-left">{{ props.item.email }}</td>
                        <td class="text-xs-right">
                          <div v-if="$route.params.app_id !== '91'"
                               style="position: relative">
                            <v-progress-circular style="position: absolute; color: #2196f326 !important;"
                                                 v-if="props.item.status === 'running'"
                                                 :disabled="props.item.progress > 0"
                                                 indeterminate
                            ></v-progress-circular>
                            <v-progress-circular v-if="props.item.status === 'running'"
                                                 :disabled="props.item.progress > 0"
                                                 color="blue"
                                                 :value="props.item.progress">
                              {{ props.item.progress }}
                            </v-progress-circular>
                          </div>
                          <!-- <div v-else>Please wait...</div> -->
                        </td>
                        <td class="text-xs-left">
                          <v-btn :disabled="loadingDataTable || !props.item.is_ready" round
                                 color="info"
                                 @click="downloadRunInputTemplate(props.item)"
                                 title="Download run input file"
                                 class="btn-datatable--action min-width-btn">
                            <v-icon small class="small-icon">fas fa-upload</v-icon>
                          </v-btn>
                        </td>
                        <td class="text-xs-left">
                          <v-btn :disabled="loadingDataTable" v-if="props.item.status === 'success'" round
                                 color="success"
                                 @click="getDownloadLink(props.item)"
                                 title="Download run output file"
                                 class="btn-datatable--action min-width-btn">
                            <v-icon small class="small-icon">fas fa-download</v-icon>
                          </v-btn>
                        </td>
                        <td class="text-xs-right">
                          <v-icon :disabled="loadingDataTable"
                                  @click="checkIfCancelOrRemove(props.item, props.index);"
                                  slot="activator"
                                  class="red--text pointer">close
                          </v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
          <v-dialog v-model="dialog_cancel" max-width="290">
            <v-card>
              <v-card-title class="headline">Stop Run</v-card-title>
              <v-card-text>Are you sure you want to cancel this run?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue" flat="flat" @click.native="dialog_cancel = false">Cancel</v-btn>
                <v-btn color="red darken-1" dark @click.native="cancelOrRemove">Stop
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_remove" max-width="290">
            <v-card>
              <v-card-title class="headline">Remove Run</v-card-title>
              <v-card-text>Are you sure you want to remove this run?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue" flat="flat" @click.native="dialog_remove = false">Cancel</v-btn>
                <v-btn color="red darken-1" dark @click.native="cancelOrRemove">Remove
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="settings_dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile>
              <v-toolbar card dark color="primary">
                <v-btn icon dark @click.native="settings_dialog = false;">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Settings</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark flat @click.native="settings_dialog = false">Save</v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <v-list three-line subheader>
                  <v-subheader>Parameters</v-subheader>
                  <v-divider></v-divider>
                  <v-list-tile avatar>
                    <v-list-tile-action>
                      <v-checkbox v-model="notifications"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Notifications</v-list-tile-title>
                      <v-list-tile-sub-title>Notify me about updates to apps or games that I downloaded
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-action>
                      <v-checkbox v-model="sound"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Sound</v-list-tile-title>
                      <v-list-tile-sub-title>Auto-update apps at any time. Data charges may apply
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-subheader>Standard with focus</v-subheader>
                    </v-flex>
                    <v-flex xs2>
                      <v-select
                        :items="items"
                        v-model="e2"
                        label="Select"
                        class="input-group--focused"
                        item-value="text"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs2>
                      <v-subheader>Focus</v-subheader>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        name="input-2"
                        label="Label Text"
                        value="Input text"
                        class="input-group--focused"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-slider :max="255" v-model="s01" label="Teste Slider 1"></v-slider>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field v-model="s01" type="number"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-slider :max="255" v-model="s02" label="Teste Slider 2"></v-slider>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field v-model="s02" type="number"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-slider :max="255" v-model="s03" label="Teste Slider 3"></v-slider>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field v-model="s03" type="number"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-subheader>Standard with focus</v-subheader>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field v-model="s01" type="number"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-subheader>Standard with focus</v-subheader>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field v-model="s02" type="number"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2>
                      <v-subheader>Standard with focus</v-subheader>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field v-model="s03" type="number"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-list>
              </v-card-text>
              <div style="flex: 1 1 auto;"></div>
            </v-card>
          </v-dialog>
          <v-dialog v-model="createNewRunDialog" max-width="800px">
            <!-- <multiple-file-uploader postURL="http://.." successMessagePath=""
                                    errorMessagePath=""></multiple-file-uploader> -->
            <v-card>

              <v-card-text>
                <v-stepper v-model="stepDialog">
                  <v-stepper-header>
                    <v-stepper-step :complete="stepDialog > 1" step="1">Create a Run</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      v-if="hasUpload"
                      :complete="stepDialog > 2" step="2">Upload and Download Template
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      v-if="hasntUpload"
                      step="2">Success!
                    </v-stepper-step>
                    <v-stepper-step
                      v-else
                      step="3">Success!
                    </v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <div class="modal-title mb-3">To create a run insert a name and the respective parameters</div>
                      <v-flex xs12 sm6 md5>

                        <v-text-field
                          v-model="newRunName"
                          label="Run Name"
                          :prefix="setPrefixes(newRunName)"
                        ></v-text-field>

                      </v-flex>

                      <v-layout v-if="$route.params.app_id === '121'" row wrap>
                        <div class="modal-title mt-3">Define the new run
                          parameters
                        </div>
                        <v-flex xs12>
                          <v-checkbox v-model="complexidade" label="Generate Complexity"></v-checkbox>
                        </v-flex>
                      </v-layout>

                      <template v-if="$route.params.app_id !== '91'">
                        <v-divider></v-divider>


                        <div v-if="isNotPipa">
                          <div v-if="$route.params.app_id !== '103'" class="modal-title mt-3 mb-3">Define the new run
                            parameters
                          </div>

                          <template v-if="$route.params.app_id === '127' || $route.params.app_id === '128'">
                            <p>Choose a program segment</p>
                            <v-select
                              class="mt-3"
                              v-model="seg_plng"
                              :items="wao_list"
                              item-text="option"
                              item-value="id"
                              return-object
                              label="Segmento Planogramável"
                              solo
                            ></v-select>
                          </template>

                          <template v-if="$route.params.app_id === '127'">
                            <p>Choose a process type</p>
                            <v-select
                              class="mt-3"
                              v-model="wao_process_types"
                              :items="WAOProcessTypesList"
                              item-text="option"
                              item-value="id"
                              return-object
                              label="Tipo de Processo"
                              solo
                            ></v-select>
                          </template>

                          <div v-if="$route.params.app_id === '128'" class="mt-2">
                            <v-layout row wrap>
                              <v-flex justify-end md3 class="checkbox-wrapper">
                                <v-checkbox label="Gerar Perfis" v-model="generate_profiles"></v-checkbox>
                                <v-checkbox label="Gerar Fatores" v-model="generate_factors"></v-checkbox>
                                <v-checkbox label="Gerar Métricas" v-model="generate_metrics"></v-checkbox>
                              </v-flex>
                            </v-layout>
                          </div>

                          <template v-if="$route.params.workspace_id !== '13'">
                            <v-layout v-if="$route.params.app_id !== '103'" row wrap>
                              <v-flex xs12 sm12 md6 lg6>
                                <v-radio-group v-model="run_base_model">
                                  <v-radio
                                    v-for="option in run_base"
                                    :key="option"
                                    :label="option"
                                    :value="option"
                                  ></v-radio>
                                </v-radio-group>
                              </v-flex>
                              <v-flex xs12 sm12 md6 lg6>
                                <multiselect
                                  v-if="run_base_model === 'Select another base for the run'"
                                  class="mt-5"
                                  v-model="value"
                                  :options="runs"
                                  :custom-label="nameWithLang"
                                  placeholder="Select one"
                                  label="name"
                                  track-by="name"></multiselect>
                              </v-flex>
                            </v-layout>
                          </template>


                          <div v-if="$route.params.app_id === '103'">

                            <v-row>
                              <v-col cols="12">
                                <div class="modal-title mt-3 mb-3"><strong>Run Settings</strong></div>
                                <v-layout row wrap>
                                  <v-flex xs3>
                                    <v-select
                                      :items="bluepharmaParamsType"
                                      v-model="selectedBluepharmaParamsType"
                                      label="Run Type"
                                      outlined
                                      dense
                                    ></v-select>
                                  </v-flex>
                                </v-layout>

                                <div v-if="selectedBluepharmaParamsType === 'Optimization'">
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-slider
                                        class="mt-5 pr-5"
                                        v-model="bluepharmaParamsModel.obj_n_delayed_orders"
                                        :max="5"
                                        step="1"
                                        thumb-label="always"
                                        label="Nr. of Delayed Orders"
                                        tick-size="5"
                                      ></v-slider>
                                      <v-slider
                                        class="mt-5 pr-5"
                                        v-model="bluepharmaParamsModel.obj_delay_time"
                                        :max="5"
                                        step="1"
                                        thumb-label="always"
                                        label="Delay Time"
                                        tick-size="5"
                                      ></v-slider>
                                      <v-slider
                                        class="mt-5 pr-5"
                                        v-model="bluepharmaParamsModel.obj_prod_efficiency"
                                        :max="5"
                                        step="1"
                                        thumb-label="always"
                                        label="Production Efficiency"
                                        tick-size="5"
                                      ></v-slider>
                                      <v-slider
                                        class="mt-5 pr-5"
                                        v-model="bluepharmaParamsModel.obj_revenue"
                                        :max="5"
                                        step="1"
                                        thumb-label="always"
                                        label="Revenue"
                                        tick-size="5"
                                      ></v-slider>
                                    </v-flex>

                                  </v-layout>
                                  <v-divider></v-divider>
                                </div>
                              </v-col>
                            </v-row>
                          </div>

                        </div>

                        <div v-if="$route.params.app_id === '96' || $route.params.app_id === '94'"
                             class="modal-title mt-3">Define the type of process
                        </div>

                        <v-row v-if="$route.params.app_id === '96'">
                          <v-col cols="12">
                            <v-radio-group v-model="selectedProcess.longTermApp">
                              <v-radio
                                v-for="option in processTypes"
                                :key="option.type"
                                :label="option.name"
                                :value="option.type"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>

                        <!--  <v-row v-if="$route.params.app_id === '103'">
                           <v-col cols="12">
                             <v-radio-group v-model="selectedProcess.longTermApp">
                               <v-radio
                                 v-for="option in processTypes"
                                 :key="option.type"
                                 :label="option.name"
                                 :value="option.type"
                               ></v-radio>
                                     <v-slider
                                     v-model="value"
                                     :rules="rules"
                                     label="How many?"
                                     step="10"
                                     thumb-label="always"
                                     ticks
                                   ></v-slider>
                           </v-col>
                         </v-row> -->

                        <v-row v-if="$route.params.app_id === '94'">
                          <v-col cols="12">
                            <v-radio-group v-model="selectedProcess.shortTermApp">
                              <v-radio
                                v-for="option in shortProcessTypes"
                                :key="option.type"
                                :label="option.name"
                                :value="option.type"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>

                        <div v-if="$route.params.workspace_id === '2' || $route.params.app_id === '184'">
                          <v-layout justify-space-between row wrap>
                            <v-flex xs6 sm6 md3 lg3>
                              <v-subheader class="label-style pl-0">Settings</v-subheader>
                            </v-flex>
                          </v-layout>
                          <v-form>
                            <v-container style="padding-left: 0 !important;" class="force-pl-0">
                              <v-layout row wrap>
                                <v-flex v-for="input in superbock_run_params_list.settings" :key="input.name" xs12 sm6
                                        md3>
                                  <v-text-field :label="input.label" type="number"
                                                :suffix="input.unit_type"
                                                :key="input.name"
                                                v-model="input.value"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex v-for="checkbox in superbock_run_params_list.checkboxes" :key="checkbox.name"
                                        xs12 sm6 md4>
                                  <div class="flex-it">
                                    <v-checkbox v-model="checkbox.value" :label="checkbox.label"></v-checkbox>
                                    <v-flex md3>
                                      <v-text-field v-if="checkbox.has_input" type="number"
                                                    :disabled="!checkbox.value"
                                                    :placeholder="checkbox.input.placeholder"
                                                    :key="checkbox.name"
                                                    v-model="checkbox.input.value"></v-text-field>
                                    </v-flex>
                                  </div>
                                </v-flex>
                              </v-layout>

                              <v-layout
                                align-content-space-between
                                row
                                wrap
                              >
                                <template v-for="slider in superbock_run_params_list.sliders">
                                  <v-flex xs11>
                                    <v-slider
                                      v-model="slider.value"
                                      :max="20"
                                      suffix="%"
                                      :label="slider.label"
                                    ></v-slider>
                                  </v-flex>

                                  <v-flex xs1>
                                    <v-text-field
                                      v-model="slider.value"
                                      class="mt-0"
                                      type="number"
                                    ></v-text-field>
                                  </v-flex>

                                </template>

                              </v-layout>
                            </v-container>
                          </v-form>
                        </div>
                        <div v-else-if="$route.params.workspace_id === '13'">
                          <div v-if="$route.params.app_id === '127'">
                            <v-flex xs6 sm6 md3 lg3>
                              <v-subheader class="label-style pl-0">Total Run Time</v-subheader>
                            </v-flex>
                            <v-flex xs3 sm3 md3 lg3>
                              <v-text-field min="300" max="18000" suffix="seconds"
                                            v-model="wao_optimizer_run_time"
                                            :rules="[numberRule]"
                                            hint="'Enter a number between 300 and 18000 seconds'"
                                            type="number"></v-text-field>
                            </v-flex>
                          </div>
                        </div>
                        <div v-else>

                          <v-layout v-if="isNotPipa" justify-space-between row wrap>
                            <v-flex v-if="selectedBluepharmaParamsType !== 'Validation'" xs6 sm6 md3 lg3>
                              <v-subheader class="label-style pl-1">Total Run Time</v-subheader>
                            </v-flex>
                            <v-flex xs3 sm3 md3 lg3>
                              <v-text-field
                                v-if="selectedBluepharmaParamsType === 'Optimization' && ($route.params.app_id === '103' && $route.params.workspace_id === '8')"
                                min="30"
                                max="180"
                                suffix="minutes"
                                v-model="run_time"
                                type="number"></v-text-field>
                              <span
                                v-else-if="selectedBluepharmaParamsType === 'Validation' && ($route.params.app_id === '103' && $route.params.workspace_id === '8')"></span>
                              <v-text-field v-else min="0" max="60" suffix="minutes" v-model="run_time"
                                            type="number"></v-text-field>
                            </v-flex>
                          </v-layout>
                        </div>
                        <v-layout v-if="$route.params.workspace_id === '5' || $route.params.workspace_id === '9'">
                          <v-flex xs12 sm6 md6>
                            <div>
                              <v-flex xs12>
                                <v-checkbox v-model="is_for_test" label="For test purpose only"></v-checkbox>
                              </v-flex>
                            </div>
                          </v-flex>
                        </v-layout>
                      </template>

                      <v-layout justify-end>
                        <v-btn
                          :loading="create_run_loader === 'loading'"
                          :disabled="create_run_loader === 'loading' || newRunName === '' || (newRunName === '' && (selectedProcess.longTermApp === '' || selectedProcess.shortTermApp === '')) || (run_base_model === 'Select another base for the run' && value === null) || (wao_optimizer_run_time < 300 || wao_optimizer_run_time > 18000)"
                          color="primary"
                          class="text-capitalize"
                          @click="createRun">Create Run
                        </v-btn>
                      </v-layout>

                    </v-stepper-content>
                    <v-stepper-content step="2"
                                       v-if="hasntUpload">
                      <v-layout align-center justify-space-around>
                        <v-icon size="170" color="green accent-3">fas fa-check-circle</v-icon>
                      </v-layout>
                      <v-layout justify-center row wrap>
                        <v-flex xs5 class="text-md-center">

                          <div class="mt-3">
                            <h2 class="mb-2"><strong>Success!</strong></h2>
                            <strong>{{ createdRun.name }}</strong> was created and was set to run!
                          </div>

                        </v-flex>
                      </v-layout>
                      <v-layout justify-end>
                        <v-btn class="text-capitalize" color="primary" @click.native="closeDialog">Close</v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2" v-else>
                      <v-layout class="mb-2" justify-center align-center>
                        <v-flex xs12 sm12 md8 lg8>
                          <div
                            v-if="$route.params.app_id === '96' && selectedProcess['shortTermApp'] === 'business_plan'"
                            class="modal-title">Download the Business
                            Plan file template, change its settings and upload it to
                            update the new run's configurations
                          </div>
                          <div
                            v-else-if="$route.params.app_id === '94' && selectedProcess['shortTermApp'] === 'full_short_term_forecast_generation'"
                            class="modal-title">Download the Full Short
                            Term Forecast Generation file template, change its settings and upload it to
                            update the new run's configurations
                          </div>
                          <div
                            v-else-if="$route.params.app_id === '96' && selectedProcess['shortTermApp'] === 'budget_upload_drill_down'"
                            class="modal-title">
                            Download the Budget file template, change its settings and upload it to
                            update the new run's configurations
                          </div>
                          <div v-else class="modal-title">Download the Configurations File template, change its settings
                            and
                            upload it to
                            update the new run's configurations
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 md4 lg4>
                          <v-btn :loading="!download_file_url"
                                 :disabled="!download_file_url"
                                 class="mb-4 mt-4 text-capitalize"
                                 color="primary"
                                 download :href="download_file_url">Download Template
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-divider></v-divider>
                      <v-layout class="ma-4" justify-center align-center>
                        <input v-if="uploadPercentage === 0" type="file" ref="file"
                               @change="handleFileUpload($event.target.files)"/>
                        <progress class="margin-progress"
                                  v-if="uploadPercentage > 0"
                                  max="100"
                                  :value.prop="uploadPercentage"></progress>
                        <v-btn :disabled="file === '' || Object.keys(file).length === 0 || !upload_is_ready"
                               class="text-capitalize"
                               @click="uploadTemplateCustomFile">Upload File
                        </v-btn>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-layout align-center justify-space-around>
                        <v-icon size="170" color="green accent-3">fas fa-check-circle</v-icon>
                      </v-layout>
                      <v-layout justify-center row wrap>
                        <v-flex xs5 class="text-md-center">

                          <div class="mt-3">
                            <h2 class="mb-2"><strong>Success!</strong></h2>
                            <strong>{{ createdRun.name }}</strong> was created and was set to run!
                          </div>

                        </v-flex>
                      </v-layout>
                      <v-layout justify-end>
                        <v-btn class="text-capitalize" color="primary" @click.native="closeDialog">Close</v-btn>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card-text>
            </v-card>

          </v-dialog>
        </v-layout>

        <div class="speed-dial--position">
          <v-speed-dial
            fixed
            v-model="fab"
            :top="top"
            :bottom="bottom"
            :right="right"
            :left="left"
            :direction="direction"
            :open-on-hover="hover"
            :transition="transition"
          >
            <v-btn @click="getGeneralUploadLink"
                   fab
                   dark
                   small
                   title="Download run template"
                   color="indigo"
            >
              <v-icon>fa-download</v-icon>
            </v-btn>
            <v-btn @click="createNewRunDialog = true;"
                   fab
                   dark
                   small
                   title="Create new run"
                   color="indigo"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <!-- <v-btn
              @click.stop="settings_dialog = true"
              fab
              dark
              small
              color="red"
            >
              <v-icon>settings</v-icon>
            </v-btn> -->
            <v-btn
              slot="activator"
              v-model="fab"
              color="blue darken-2"
              dark
              fab
            >
              <v-icon>more_horiz</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
            <!-- <v-btn
              fab
              dark
              small
              color="green"
            >
              <v-icon>edit</v-icon>
            </v-btn> -->
          </v-speed-dial>
        </div>
      </v-container>
    </v-content>
  </div>
</template>


<style lang="scss">

.checkbox-wrapper {
  .v-input--selection-controls {
    margin-top: 0 !important;
  }
}

.v-input--slider > div > div > label {
  min-width: 150px;
}

.force-pl-0 {
  padding-left: 0 !important;
}

.mb-10 {
  margin-bottom: 10px;
}

.v-toolbar__content > :first-child.v-btn--icon, .v-toolbar__extension > :first-child.v-btn--icon {
  margin-left: 15px !important;
}

.container {
  padding: 15px 24px 24px 24px !important;
}

.v-breadcrumbs {
  padding: 0 !important;
  margin-bottom: 10px !important;
}

.align-items-center {
  align-items: center;
}

.flex-it {
  display: flex;
}

a {
  color: black;
}

.v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
  background-color: transparent !important;
}

.no-underline {
  text-decoration: none !important;
}

.toast-top-right {
  top: 70px !important;
  right: 23px !important;
}

.breadcrumbs li:nth-child(2n) {
  padding: 0 7px;
}

tr {
  cursor: pointer;
}

.active-run--breadcrumb > a {
  color: #616161 !important;
}

.breadcrumbs__item {
  color: #616161 !important;
}

.current {
  background: #0033a00d;
}

.primary--text {
  color: #0033a0 !important;
}

.v-speed-dial--bottom:not(.v-speed-dial--absolute) {
  bottom: 50px !important;
}

.v-speed-dial--right {
  right: 10px !important;
}

.font-weight-500 {
  font-weight: 500;
}

.app-title {
  margin-left: 5px;
  position: relative;
  top: -25px;
  font-weight: 500;
  color: #0033a0;
}

.margin-progress {
  margin-right: 90px;
}

body {
  font-family: "Open sans", sans-serif;
  color: #333;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.speed-dial--position {
  position: absolute;
  bottom: 45px;
  right: 0;
}

.ripple__container {
  display: none !important;
}

.filter-button {
  border: none !important;
  cursor: pointer;

  .btn__content:before {
    background: transparent !important;
  }

}

#create .speed-dial {
  position: absolute;
}

#create .btn--floating {
  position: relative;
}

.app-logo--size {
  width: 119px;
  height: 32px;
}

.pointer {
  cursor: pointer;
}

.btn-datatable--action {
  min-width: 45px !important;
  height: 22px !important;
}

.modal-title {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
}

.small-icon {
  font-size: 11px !important;
}

#create .btn--floating {
  position: relative;
}

.app-logo--wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 10px 15px;
}

.chip__content, .chip {
  height: 25px !important;
}

.filter-button--wrapper {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
}

.label-style {
  font-size: 16px !important;
  margin-top: 5px !important;
}

.toast-top-right {
  top: 70px;
  right: 23px;
}

.v-breadcrumbs__item {
  color: gray;
  font-size: 12px;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import {axiosInstance} from '../axios-auth'
import Multiselect from 'vue-multiselect'
import Spinner from 'vue-spinner-component/src/Spinner.vue'
// import {required, minLength, maxLength} from 'vuelidate/lib/validators'

export default {
  /* validations: {
    seg_plng: {required, minLength: minLength(300), maxLength: maxLength(18000)}
  }, */
  data: () => ({
    plan_type: "necessidades",
    numberOfWeeks: 10,
    is_for_test: false,
    generate_profiles: false,
    generate_factors: false,
    generate_metrics: false,
    numberRule: v => {
      if (!v.trim()) return true;
      if (!isNaN(parseInt(v)) && v >= 300 && v <= 18000) return true;
      return 'Number has to be between 300 and 18000';
    },
    superbock_run_params_list: {
      settings: [
        {
          name: "number_periods",
          value: 12,
          label: 'Planning horizon',
          placeholder: "1",
          unit_type: 'months'
        },
        {
          name: "starting_period",
          value: 1,
          label: 'Starting period',
          placeholder: "1",
          unit_type: ''
        },
        {
          name: "run_time",
          value: 30,
          label: 'Total run time',
          placeholder: "30",
          unit_type: 'minutes'
        }
      ],
      checkboxes: [
        {
          has_input: false,
          input: null,
          name: 'coverage',
          label: 'Coverage',
          value: true
        },
        {
          has_input: false,
          input: null,
          name: 'prod_cost',
          label: 'Production Cost',
          value: true
        },
        {
          has_input: false,
          input: null,
          name: 'overtime',
          label: 'Overtime',
          value: true
        },
        {
          has_input: false,
          input: null,
          name: 'expiration',
          label: 'Expiration',
          value: true
        },
        {
          has_input: false,
          input: null,
          name: 'print_solver_output',
          label: 'Print Solver Output',
          value: true
        },
        {
          has_input: true,
          input: {
            value: 10,
            placeholder: "10"
          },
          name: 'align_coverage',
          label: 'Align coverage',
          value: true
        }
      ],
      sliders: [
        {
          name: 'weight_holding',
          label: 'Holding',
          value: 10
        },
        {
          name: 'weight_transfer',
          label: 'Transfer',
          value: 10
        },
        {
          name: 'weight_setup',
          label: 'Setup',
          value: 10
        },
        {
          name: 'weight_overtime',
          label: 'Overtime',
          value: 10
        },
        {
          name: 'weight_prod_cost',
          label: 'Production Cost',
          value: 10
        },
        {
          name: 'weight_external_warehousing',
          label: 'External Warehousing',
          value: 10
        }
      ]
    },
    seg_plng: {},
    wao_process_types: '',
    WAOProcessTypesList: [
      {id: 1, option: 'Atualizar perfis'},
      {id: 4, option: 'Atualizar gamas-tipo'},
      {id: 2, option: 'Atualizar alocação de gama'},
      {id: 3, option: 'Exportar ficheiros WIF'},
    ],
    wao_list: [
      {id: 1, option: 'Acessórios de Bebé'},
      {id: 2, option: 'Alimentação Infantil'},
      {id: 3, option: 'Chás e Fitoterapia'},
      {id: 4, option: 'Conforto dos Pés'},
      {id: 5, option: 'Controlo de Peso'},
      {id: 6, option: 'Cuidado do Cabelo'},
      {id: 7, option: 'Cuidado do Homem'},
      {id: 8, option: 'Cuidados Íntimos'},
      {id: 9, option: 'Equipamentos de Bebé'},
      {id: 10, option: 'Equipamentos de Saúde'},
      {id: 11, option: 'Higiene do Bebé'},
      {id: 12, option: 'Higiene Oral'},
      {id: 13, option: 'Mamã'},
      {id: 14, option: 'Mãos'},
      {id: 15, option: 'Nutricão Desportiva'},
      {id: 16, option: 'ORL'},
      {id: 17, option: 'Pernas Cansadas'},
      {id: 18, option: 'Pés'},
      {id: 19, option: 'Primeiros Socorros'},
      {id: 20, option: 'Produtos Veterinários'},
      {id: 21, option: 'Suplementos'},
      {id: 22, option: 'Suportes Ortopédicos'},
      {id: 23, option: 'Rosto & Corpo'}
    ],
    superbock_run_params: {
      number_periods: 12,
      starting_period: 1,
      coverage: true,
      prod_cost: true,
      overtime: true,
      expiration: true,
      align_coverage: false,
      print_solver_output: true,
      coverage_letiation: 10,
      weight_holding: 10,
      weight_transfer: 10,
      weight_setup: 10,
      weight_overtime: 10,
      weight_prod_cost: 10,
      weight_external_warehousing: 10,
      opt_output_unit: 'Ltrs'
    },
    rowsPerPageItems: [10, 20, 30],
    pagination: {
      sortBy: 'date',
      rowsPerPage: 10
    },
    run_base: ["None", "Select another base for the run"],
    workspaces: [],
    run_base_model: "None",
    uploadPercentage: 0,
    run_time: 30,
    file: "",
    stepDialog: 0,
    slider: 50,
    is_loading: false,
    newRunName: "",
    createdRun: {},
    createNewRunDialog: false,
    s01: 0,
    s02: 53,
    s03: 99,
    radioGroup: 1,
    download_file_url: "",
    switch1: true,
    dialog2: false,
    select: [
      {text: 'State 1'},
      {text: 'State 2'},
      {text: 'State 3'},
      {text: 'State 4'},
      {text: 'State 5'},
      {text: 'State 6'},
      {text: 'State 7'}
    ],
    notifications: false,
    sound: true,
    e2: null,
    widgets: false,
    settings_dialog: false,
    search: '',
    itemToDelete: '',
    itemIndexToDelete: '',
    status: [
      {id: 1, status: 'success', color: 'green'},
      {id: 2, status: 'pending', color: 'amber'},
      {id: 3, status: 'error', color: 'red'},
      {id: 4, status: 'running', color: 'blue'},
      {id: 5, status: 'canceled', color: 'gray'},
    ],
    checkbox: true,
    active_el: 0,
    active_status: ["success", "running", "pending", "error", "canceled"],
    dialog_cancel: false,
    dialog_remove: false,
    direction: 'top',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    create_run_loader: null,
    transition: 'slide-y-reverse-transition',
    current_active_run: {},
    items: [
      {icon: 'home', text: 'Home'},
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Apps',
        model: false,
        children: [
          {text: 'FRESHPACK'},
          {text: 'TWIX'},
          {text: 'GAP'}
        ]
      },
      {icon: 'bar_chart', text: 'Statistics'},
      {icon: 'settings', text: 'Settings'}
    ],
    items_drop: [
      {title: 'Edit Profile', path: '/edit-profile'}
    ],
    headers: [
      {text: '#', align: 'left', value: 'id'},
      {text: 'Name', align: 'left', value: 'name'},
      {text: 'Created Date', align: 'left', value: 'create_date'},
      {text: 'Status', align: 'left', value: 'status'},
      {text: 'User', align: 'left', value: 'email'},
      {text: ' ', value: 'progress', sortable: false},
      {text: '  ', value: 'estimated_time', sortable: false},
      {text: '   ', value: 'input_download', sortable: false},
      {text: '   ', value: 'download', sortable: false}
    ],
    processTypes: [
      {name: 'Business Plan (BP) Upload', type: 'business_plan'},
      {name: 'Long-term forecast generation with Business Plan', type: 'long_term_with_business_plan'},
      {name: 'Long-term forecast generation without Business Plan', type: 'long_term_no_business_plan'},
      {name: 'Budget upload and drill-down', type: 'budget_upload_drill_down'}
    ],
    shortProcessTypes: [
      {name: 'Configurations Upload', type: 'configurations_upload'},
      {name: 'Full short-term forecast generation', type: 'full_short_term_forecast_generation'},
      {name: 'Partial forecast generation (configurations update)', type: 'partial_forecast_generation'},
      {name: 'SAP export Download', type: 'sap_export_download'},
      {name: 'Full Year Projection', type: 'full_year_projection'}
    ],
    runs: [],
    itemIndex: '',
    complexidade: false,
    wao_optimizer_run_time: 300,
    link_upload: '',
    wsData: "",
    upload_is_ready: false,
    loadingDataTable: false,
    is_uploaded: false,
    value: null,
    notifications_list: [
      {
        id: 1,
        type: "Error",
        time: "12:50 AM",
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
      },
      {
        id: 2,
        type: "Warning",
        time: "11:00 AM",
        message: "Lorem ipsum dolor sit amet elit, sed do eiusmod tempor incididunt."
      },
      {
        id: 3,
        type: "Error",
        time: "10:50 AM",
        message: "Lorem ipsum dolor sit amet, consectetur lorem ipsum dolor sit"
      },
      {
        id: 4,
        type: "Warning",
        time: "09:40 AM",
        message: "Lorem ipsum dolor sit amet, consectetur ipsum dolor"
      },
      {id: 5, type: "Warning", time: "09:23 AM", message: "Lorem ipsum dolor sit amet, consectetur."},
      {
        id: 6,
        type: "Warning",
        time: "09:16 AM",
        message: "Lorem ipsum dolor sit amet, consectetur ipsum dolor ipsum dolor ipsum dolor"
      },
      {
        id: 7,
        type: "Error",
        time: "09:01 AM",
        message: "Lorem ipsum dolor sit amet, consectetur ipsum dolor ipsum dolor"
      }
    ],
    run_tabs: [
      {tab: "Statistics", id: 1},
      {tab: "Notifications", id: 2}
    ],
    run_bases: [
      {name: 'Vue.js', id: 1},
      {name: 'Rails', id: 2},
      {name: 'Sinatra', id: 3},
      {name: 'Phoenix', id: 4}
    ],
    current: {
      id: null,
      run: {}
    },
    selectedProcess: {
      shortTermApp: 'configurations_upload',
      longTermApp: 'business_plan'
    },
    current_run: {},
    active: null,
    run_download_link: "",
    run_input_link: "",
    bluepharmaParamsModel: {
      obj_n_delayed_orders: '0',
      obj_delay_time: '5',
      obj_prod_efficiency: '0',
      obj_revenue: '0',
    },
    selectedBluepharmaParamsType: "Validation",
    ticksLabels: [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5'
    ],
    bluepharmaParamsType: [
      'Validation',
      'Optimization'
    ],
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }),
  components: {
    Multiselect,
    Spinner
  },
  methods: {
    validateRunTime() {
      console.log('validateRunTime')
    },
    hasParams() {
      // this.$route.params.app_id !== '91' || this.$route.params.app_id !== '103'
    },
    resetRunName() {
      this.newRunName = ''
    },

    cancelOrRemove() {
      const self = this

      if (self.current_active_run.status === "running" || self.current_active_run.status === "pending") {
        self.cancelRun()
        self.dialog_cancel = false
      } else if (self.current_active_run.status === "error" || self.current_active_run.status === "success" || self.current_active_run.status === "canceled") {
        self.removeRun()
        self.dialog_remove = false
      } else {
        alert("Something's wrong")
      }
    },
    getDownloadLink: function (item) {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + parseInt(paramsPath.workspace_id) + '/apps/' + parseInt(paramsPath.app_id) + '/runs/' + item.id + '/output/download-link/'

      axiosInstance.get(url).then(function (response) {
        self.run_download_link = response.data
        self.downloadRunOutput()
      }).catch(function (error) {
        // TODO message
        alert("Error downloading output URL")
        console.log(error)
      })
    },
    downloadRunInputTemplate: function (item) {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + parseInt(paramsPath.workspace_id) + '/apps/' + parseInt(paramsPath.app_id) + '/runs/' + item.id + '/input/download-link/'

      axiosInstance.get(url).then(function (response) {
        window.open(response.data, '_blank')
      }).catch(function (error) {
        // TODO message
        alert("Error downloading output URL")
        console.log(error)
      })
    },
    getGeneralUploadLink: function () {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + parseInt(paramsPath.workspace_id) + '/apps/' + parseInt(paramsPath.app_id) + '/input-template/download-link/'

      axiosInstance.get(url).then(function (response) {
        window.open(response.data, '_blank')
      }).catch(function (error) {
        // TODO message
        alert("Error downloading output URL")
        console.log(error)
      })
    },
    downloadRunOutput: function () {
      window.open(this.run_download_link, '_blank')
    },
    downloadRunInput: function () {
      window.open(this.run_input_link, '_blank')
    },
    run_injection: function (item) {
      const dataset = item.app_tracking_data,
        self = this

      self.current = item.id
      self.current_active_run = item

      self.getRunDataset(item, dataset)
    },
    getRunDataset: function (item) {

      let new_dataset = item.app_tracking_data = {
        "accuracy": {
          "x": [70, 71, 72, 73],
          "y": [70, 63, 89, 80],
          "thresholds": [100, 100, 100, 100]
        },
        "precision": {
          "x": [1, 2],
          "y": [0.75, 0.78],
          "thresholds": [100, 100]
        },
      }

      function updateChartData() {
        myChart["config"]["data"]["datasets"] = [
          {data: new_dataset.accuracy.y, label: "Teste"},
          {data: new_dataset.accuracy.thresholds, label: "Thresholds"}
        ]
        myChart["config"]["data"]["labels"] = new_dataset.accuracy.x

        myChart.update()
      }

      // updateChartData();

    },
    addCenas: function () {
      this.addData(myChart, "Proteus", 140)
    },
    addData: function (chart, label, data) {
      chart.data.labels.push(label)
      chart.data.datasets.forEach((dataset) => {
        dataset.data.push(Math.random() * data)
      })
      chart.update()
    },
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId)
      self.myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      })
    },
    handleFileUpload: function (event_file) {
      this.file = event_file
    },
    nameWithLang({name}) {
      return `${name}`
    },
    setToRunHammer: function (id) {
      this.setUploadToNotRequired(id)
    },
    setToRun: function () {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/' + self.createdRun.id + '/ready/'

      axiosInstance.post(url).then(function (response) {
        // self.$toastr.s(self.createdRun.name + " was set to run!")
      }).catch(function (err) {
        self.$toastr.s(err.response.data.error)
        console.log(err)
      }).finally(function () {
        self.getRuns(paramsPath.workspace_id, paramsPath.app_id)
      })
    },
    getUploadLink: function () {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/' + self.createdRun.id + '/input/upload-link/'

      axiosInstance.get(url).then(function (response) {
        self.link_upload = response.data
        self.upload_is_ready = true
      }).catch(function (e) {
        self.excelLoading = false
        console.log(e)
      })
    },
    uploadTemplateCustomFile: function () {
      const self = this, signedUrl = self.link_upload.url

      let formData = new FormData()
      for (let key in self.link_upload.fields) {
        formData.append(key, self.link_upload.fields[key])
      }
      formData.append('file', self.file[0])
      formData.append('Content-type', "application/octet-stream")

      let options = {
        headers: null,
        onUploadProgress: function (progressEvent) {
          self.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }.bind(this)
      }

      axiosInstance.post(
        signedUrl,
        formData,
        options
      )

        .then(function (res) {
          self.setToRun()
          self.stepDialog = 3
          self.is_uploaded = true
          self.$toastr.s("Uploaded template successfully")
        })

        .catch(function (err) {
          self.excelLoading = false
          self.$toastr.e("Error uploading customized template")
          console.log(err)
        })

    },
    closeDialog() {
      const self = this

      self.createNewRunDialog = false
      self.resetCreateRun()
    },
    resetCreateRun() {
      const self = this

      self.stepDialog = 1
      self.newRunName = ""
      self.run_base_model = "None"
      self.download_file_url = ""
      self.link_upload = ""
      self.uploadPercentage = 0
      self.file = ""
    },
    createRun() {
      let self = this,
        paramsPath = self.$route.params,
        url = '/workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/',
        selectedRun = self.value,
        params

      if (selectedRun === null) {
        selectedRun = null
      } else {
        selectedRun = self.value.id
      }

      if (paramsPath.workspace_name === "Superbock" || paramsPath.app_id === "184") {

        let spParams = self.superbock_run_params_list,
          objFinal = {}

        for (let key in spParams) {

          for (let spItem of spParams[key]) {

            let name = spItem.name,
              value = spItem.value

            objFinal[name] = value

          }

        }

        objFinal.run_name = self.newRunName

        params = {
          name: self.newRunName,
          parameters: objFinal
        }

        params.parameters.run_time = params.parameters.run_time * 60

      } else if (paramsPath.workspace_id === "5" || paramsPath.workspace_id === "9") {
        params = {
          name: self.newRunName,
          parameters: {
            run_name: self.newRunName,
            run_id: selectedRun,
            run_time: parseInt(self.run_time) * 60,
            is_for_test: this.is_for_test
          }
        }
      } else if (this.$route.params.app_id === "96") {
        let prefix = ''

        if (this.selectedProcess['longTermApp'] === 'business_plan') {
          prefix = 'BP_'
        } else if (this.selectedProcess['longTermApp'] === 'long_term_with_business_plan') {
          prefix = 'FullRunBP_'
        } else if (this.selectedProcess['longTermApp'] === 'long_term_no_business_plan') {
          prefix = 'FullRun_'
        } else if (this.selectedProcess['longTermApp'] === 'budget_upload_drill_down') {
          prefix = 'Budget_'
        }

        let runName = prefix + self.newRunName

        params = {
          name: runName,
          parameters: {
            run_name: runName,
            run_id: selectedRun,
            run_time: 43200,
            process_type: this.selectedProcess['longTermApp']
          }
        }
      } else if (this.$route.params.app_id === "118" || this.$route.params.app_id === "119" || this.$route.params.app_id === '120') {
        params = {
          name: self.newRunName,
          parameters: {
            run_name: self.newRunName
          }
        }
      } else if (this.$route.params.app_id === "127") {
        debugger
        let type

        if (this.wao_process_types.id === 1) {
          type = 'RUN_PERFIS'
        } else if (this.wao_process_types.id === 2) {
          type = 'RUN_OTIMIZADOR_GAMA'
        } else if (this.wao_process_types.id === 3) {
          type = 'RUN_EXPORT_GT_WIF'
        } else if (this.wao_process_types.id === 4) {
          type = 'RUN_GT_OPTIMIZER'
        }

        params = {
          name: self.newRunName,
          parameters: {
            run_name: self.newRunName,
            run_time: Number.parseInt(self.wao_optimizer_run_time),
            process_type: type,
            seg_plng_id: self.seg_plng.id
          }
        }
      } else if (this.$route.params.app_id === "128") {
        params = {
          name: self.newRunName,
          parameters: {
            run_name: self.newRunName,
            run_time: null,
            seg_plng_id: self.seg_plng.id,
            generate_profiles: self.generate_profiles,
            generate_factors: self.generate_factors,
            generate_metrics: self.generate_metrics
          }
        }
      } else if (this.$route.params.app_id === "94") {
        let prefix = ''

        if (this.selectedProcess['shortTermApp'] === 'configurations_upload') {
          prefix = 'Config_'
        } else if (this.selectedProcess['shortTermApp'] === 'full_short_term_forecast_generation') {
          prefix = 'FullRun_'
        } else if (this.selectedProcess['shortTermApp'] === 'partial_forecast_generation') {
          prefix = 'PartialRun_'
        } else if (this.selectedProcess['shortTermApp'] === 'sap_export_download') {
          prefix = 'SAP_'
        } else if (this.selectedProcess['shortTermApp'] === 'full_year_projection') {
          prefix = 'FYP_'
        }

        let runName = prefix + self.newRunName

        params = {
          name: runName,
          parameters: {
            run_name: runName,
            run_id: selectedRun,
            run_time: 43200,
            process_type: this.selectedProcess['shortTermApp']
          }
        }
      } else if (this.$route.params.app_id === "121") {
        params = {
          name: this.newRunName,
          parameters: {
            run_name: this.newRunName,
            complexidade: this.complexidade
          }
        }
      } else {
        params = {
          name: self.newRunName,
          parameters: {
            run_name: self.newRunName,
            run_id: selectedRun,
            run_time: parseInt(self.run_time) * 60
          }
        }
      }

      if (paramsPath.app_name === "Revisão dos stocks de segurança") {
        params = {
          name: self.newRunName,
          parameters: {
            run_name: self.newRunName,
          }
        }
      }

      if (paramsPath.app_id === "103") {
        let prefix = '';

        if (this.selectedBluepharmaParamsType === 'Validation') {
          prefix = 'Validation_';
        } else {
          prefix = 'Optimization_';
        }

        let runName = prefix + self.newRunName;

        if (this.selectedBluepharmaParamsType === 'Validation') {
          params = {
            name: runName,
            parameters: {
              run_name: runName,
              run_id: selectedRun,
              run_time: null,
              run_type: 'validation'
            }
          }
        } else {
          params = {
            name: runName,
            parameters: {
              run_type: 'optimization',
              run_name: runName,
              run_id: selectedRun,
              run_time: parseFloat(self.run_time),
              obj_n_delayed_orders: parseFloat(self.bluepharmaParamsModel.obj_n_delayed_orders),
              obj_delay_time: parseFloat(self.bluepharmaParamsModel.obj_delay_time),
              obj_prod_efficiency: parseFloat(self.bluepharmaParamsModel.obj_prod_efficiency),
              obj_revenue: parseFloat(self.bluepharmaParamsModel.obj_revenue)
            }
          }
        }

      }

      if (self.value !== null) {
        params.parameters.initial_solution_id = selectedRun
      }

      self.create_run_loader = 'loading'

      axiosInstance.post(url, params).then(function (response) {
        // self.$toastr.s(self.createdRun.name + " created with success!")
        self.createdRun = response.data
        self.current = self.createdRun.id
        self.create_run_loader = null
        self.stepDialog = 2

        // reset bluepharma configs
        self.bluepharmaParamsModel = {
          obj_n_delayed_orders: '0',
          obj_delay_time: '5',
          obj_prod_efficiency: '0',
          obj_revenue: '0',
        }
        self.selectedBluepharmaParamsType = 'Validation'

        if ((self.$route.params.app_id === '96' && self.selectedProcess['longTermApp'] === 'long_term_no_business_plan') ||
          (self.$route.params.app_id === '96' && self.selectedProcess['longTermApp'] === 'long_term_with_business_plan') ||
          (self.$route.params.app_id === '94' && self.selectedProcess['shortTermApp'] === 'partial_forecast_generation') ||
          (self.$route.params.app_id === '94' && self.selectedProcess['shortTermApp'] === 'full_year_projection') ||
          (self.$route.params.app_id === '94' && self.selectedProcess['shortTermApp'] === 'full_short_term_forecast_generation') ||
          (self.$route.params.app_id === '94' && self.selectedProcess['shortTermApp'] === 'sap_export_download') ||
          (self.$route.params.app_id === '126') ||
          (self.$route.params.app_id === '127') ||
          (self.$route.params.app_id === '128')) {
          self.setToRunHammer(self.current)
        } else {
          self.getExcelTemplate()
        }
      }).catch(function (error) {
        self.create_run_loader = null
        self.$toastr.e("There occurred an error creating a run")
        console.log(error)
      })

    },
    cancelRun() {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/' + self.itemToDelete.id + '/cancel/'

      axiosInstance.post(url).then(function (response) {
        self.runs.splice(self.itemIndexToDelete, 1)
        self.$toastr.s("Run successfully canceled")
      }).catch(function (error) {
        self.$toastr.e("Error deleting run")
        console.log(error)
      })
    },
    getExcelTemplate() {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/input-template/download-link/'

      axiosInstance.get(url).then(function (response) {
        self.download_file_url = response.data
      }).catch(function (error) {
        console.log(error)
      }).finally(function () {
        self.getUploadLink()
      })

    },
    logout() {
      let self = this,
        url = 'accounts/logout/'

      axiosInstance.post(url).then(function () {
        self.$toastr.s("Logged Out")
      }).catch(function (error) {
        self.$toastr.e("ERROR Logging Out")
        console.log(error)
      })
    },
    getRuns(workspaceId, appId) {
      const self = this

      if (workspaceId === undefined) {
        workspaceId = self.$route.params.workspace_id
        appId = self.$route.params.app_id
      }

      let url = 'workspaces/' + workspaceId + '/apps/' + appId + '/runs/'

      self.loadingDataTable = true

      axiosInstance.get(url).then(function (response) {
        let runs = self.runs = response.data

        // Sort Runs for current_active_run
        let sorted_runs_by_id = response.data.sort(function (item) {
          return item.id
        })

        function compare(a, b) {
          if (a.id < b.id) {
            return -1
          }
          if (a.id > b.id) {
            return 1
          }
          return 0
        }

        sorted_runs_by_id.sort(compare)
        sorted_runs_by_id.reverse()

        self.current = sorted_runs_by_id[0].id
        self.current_active_run = self.runs[0]
        // End -- Sort Runs for current_active_run

        self.runs[0].app_tracking_data = {
          "accuracy": {
            "x": [23, 24, 25, 26],
            "y": [70, 63, 89, 80],
            "thresholds": [80, 80, 80, 80]
          },
          "precision": {
            "x": [1, 2],
            "y": [0.75, 0.78],
            "thresholds": [1.0, 1.0]
          },
        }

        for (let i = 0; i < runs.length; i++) {

          runs[i].progress *= 100
          runs[i].email = runs[i].user.email

          runs[i].create_hour = runs[i].create_date.substring(11, 19)

          // Dates
          if (runs[i].create_date) {
            runs[i].create_date = runs[i].create_date.substring(0, 10)
          }

          if (runs[i].end_date) {
            runs[i].end_date = runs[i].end_date.substring(0, 10)
          }

          // States
          if (runs[i].status === "SUC") {
            runs[i].status = "success"
          } else if (runs[i].status === "PRE") {
            runs[i].status = "pending"
          } else if (runs[i].status === "ERR") {
            runs[i].status = "error"
          } else if (runs[i].status === "CCL") {
            runs[i].status = "canceled"
          } else if (runs[i].status === "RUN") {
            runs[i].status = "running"
          }

        }

        self.loadingDataTable = false

      }).catch(function (err) {
        self.loadingDataTable = false
        // self.$toastr.e(err.data.response.error);
        console.log(err)
      }).finally(function () {
        // console.log("self.runChart.data.labels", self.runChart.data.labels);
        // console.log("app_tracking_data", self.current_active_run.app_tracking_data);
        // self.createChart('run-chart', self.runChart);
        // self.createChart('run-chart-2', self.runChart2);
        // self.createChart('run-chart-3', self.runChart3);
        // console.log(self.current_active_run.app_tracking_data.accuracy.x);
        // self.runChart.data.labels = self.current_active_run.app_tracking_data.accuracy.x;
        // self.runChart.data.datasets[0].data = self.current_active_run.app_tracking_data.accuracy.y;
        // self.runChart.data.datasets[1].data = self.current_active_run.app_tracking_data.accuracy.thresholds;

      })
    },
    activate: function (el) {
      this.active_el = el
    },
    checkIfCancelOrRemove(item, index) {
      const self = this
      self.itemToDelete = item
      self.itemIndexToDelete = index

      if (self.current_active_run.status === "running" || self.current_active_run.status === "pending") {
        self.dialog_cancel = true
      } else if (self.current_active_run.status === "error" || self.current_active_run.status === "success" || self.current_active_run.status === "canceled") {
        self.dialog_remove = true
      } else {
        alert("Something's wrong")
      }
    },
    setUploadToNotRequired(id) {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/' + id + '/',
        params = {'is_input_required': false},
        url2 = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/' + self.createdRun.id + '/input/upload-link/'

      axiosInstance.get(url2).then(function (response) {
        self.link_upload = response.data
        self.upload_is_ready = true
      }).catch(function (e) {
        self.excelLoading = false
        console.log(e)
      }).finally(function () {
        axiosInstance.put(url, params).then(function (resp) {
          self.setToRun()
        }).catch(function (err) {
          self.$toastr.s(err.response.data.error)
          console.log(err)
        })
      })

    },
    removeRun() {
      let self = this,
        paramsPath = self.$route.params,
        url = 'workspaces/' + paramsPath.workspace_id + '/apps/' + paramsPath.app_id + '/runs/' + self.itemToDelete.id

      axiosInstance.delete(url).then(function () {
        self.runs.splice(self.itemIndexToDelete, 1)
        self.$toastr.s("Run successfully deleted")
      }).catch(function (error) {
        self.$toastr.e("Error deleting run")
        console.log(error)
      })
    },
    connectWS(app_id) {
      const self = this

      if (app_id === undefined) {
        app_id = self.$route.params.app_id
      }

      let feedSocket = ""

      if (process.env.NODE_ENV === "development") {
        feedSocket = new WebSocket('ws://localhost:8000' + '/ws/v1/apps/' + app_id + '/feed/')
      } else {
        feedSocket = new WebSocket('wss://' + window.location.host + '/ws/v1/apps/' + app_id + '/feed/')
      }

      feedSocket.onmessage = function (e) {
        self.wsData = JSON.parse(e.data)
        console.log("Feed Socket Received:", self.wsData)
      }
    },
    setPrefixes(newRunName) {
      newRunName = ''

      if (this.$route.params.app_id === "94") {
        if (this.selectedProcess['shortTermApp'] === 'configurations_upload') {
          newRunName = 'Config_'
        } else if (this.selectedProcess['shortTermApp'] === 'full_short_term_forecast_generation') {
          newRunName = 'FullRun_'
        } else if (this.selectedProcess['shortTermApp'] === 'partial_forecast_generation') {
          newRunName = 'PartialRun_'
        } else if (this.selectedProcess['shortTermApp'] === 'sap_export_download') {
          newRunName = 'SAP_'
        } else if (this.selectedProcess['shortTermApp'] === 'full_year_projection') {
          newRunName = 'FYP_'
        }
      } else if (this.$route.params.app_id === "96") {
        if (this.selectedProcess['longTermApp'] === 'business_plan') {
          newRunName = 'BP_'
        } else if (this.selectedProcess['longTermApp'] === 'long_term_with_business_plan') {
          newRunName = 'FullRunBP_'
        } else if (this.selectedProcess['longTermApp'] === 'long_term_no_business_plan') {
          newRunName = 'FullRun_'
        } else if (this.selectedProcess['longTermApp'] === 'budget_upload_drill_down') {
          newRunName = 'Budget_'
        }
      } else if (this.$route.params.app_id === "103") {
        if (this.selectedBluepharmaParamsType === 'Optimization') {
          newRunName = 'Optimization_'
        } else {
          newRunName = 'Validation_'
        }
      }

      return newRunName
    }
  },
  watch: {
    runs: {
      handler: function (val) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].status === 'running') {
            function t() {
              let start_date = new Date(val[i].start_date),
                current = new Date(),
                timeout = 3600

              val[i].progress = parseInt(Math.min(((current - start_date) / (timeout * 1000)) * 100.0, 100.0))
            }

            setInterval(t, 1000)
          }
        }
      },
    },
    wsData(val) {
      const self = this
      self.runs = self.runs.map(function (run) {
        return run.id === val.id ? val : run
      })

      for (let i = 0; i < self.runs.length; i++) {
        if (self.runs[i].id === val.id) {
          //Vue.set(self.runs, [i], val)
          // self.runs[i] = val
          self.runs[i].progress *= 100

          if (self.runs[i].create_date) {
            self.runs[i].create_date = self.runs[i].create_date.substring(0, 10)
          }

          if (self.runs[i].end_date) {
            self.runs[i].end_date = self.runs[i].end_date.substring(0, 10)
          }

          if (self.runs[i].status === "SUC") {
            self.runs[i].status = "success"
          } else if (self.runs[i].status === "PRE") {
            self.runs[i].status = "pending"
          } else if (self.runs[i].status === "ERR") {
            self.runs[i].status = "error"
          } else if (self.runs[i].status === "RUN") {
            self.runs[i].status = "running"
          }
        }
      }
      // self.runs = self.runs.slice(0)
    },
    '$route'(to, from) {
      const self = this

      self.getRuns(to.params.workspace_id, to.params.app_id)
      // self.connectWS(to.params.app_id);
    }
  },
  created() {
    this.getRuns()
    this.connectWS(this.$route.params.app_id)
  },
  computed: {
    hasUpload() {
      if (((this.$route.params.app_id === '96' && this.selectedProcess['longTermApp'] === 'budget_upload_drill_down') ||
          (this.$route.params.app_id === '94' && this.selectedProcess['shortTermApp'] === 'configurations_upload') ||
          (this.$route.params.app_id === '96' && this.selectedProcess['longTermApp'] === 'business_plan')) ||
        this.$route.params.app_id === '118' || this.$route.params.app_id === '119' || this.$route.params.app_id === '120' || this.$route.params.app_id === '121' || this.$route.params.app_id === '122' || this.$route.params.app_id === '123' || this.$route.params.app_id === '124' || this.$route.params.app_id === '125'
        ||
        (this.$route.params.workspace_id === "1" || this.$route.params.workspace_id === "2" || this.$route.params.workspace_id === "5" || this.$route.params.workspace_id === "8" || this.$route.params.workspace_id === "9")) {
        return true
      } else {
        return false
      }
    },
    hasntUpload() {
      if ((this.$route.params.app_id === '96' && this.selectedProcess['longTermApp'] === 'long_term_with_business_plan') ||
        (this.$route.params.app_id === '96' && this.selectedProcess['longTermApp'] === 'long_term_no_business_plan') ||
        (this.$route.params.app_id === '94' && this.selectedProcess['shortTermApp'] === 'full_short_term_forecast_generation') ||
        (this.$route.params.app_id === '94' && this.selectedProcess['shortTermApp'] === 'partial_forecast_generation') ||
        (this.$route.params.app_id === '94' && this.selectedProcess['shortTermApp'] === 'full_year_projection') ||
        (this.$route.params.app_id === '94' && this.selectedProcess['shortTermApp'] === 'sap_export_download') ||
        (this.$route.params.app_id === '126') ||
        (this.$route.params.app_id === '127') ||
        (this.$route.params.app_id === '128')) {
        return true
      } else {
        return false
      }
    },
    isNotPipa() {
      if (this.$route.params.app_id === '94' ||
        this.$route.params.app_id === '95' ||
        this.$route.params.app_id === '118' ||
        this.$route.params.app_id === '119' ||
        this.$route.params.app_id === '120' ||
        this.$route.params.app_id === '121' ||
        this.$route.params.app_id === '122' ||
        this.$route.params.app_id === '123' ||
        this.$route.params.app_id === '124' ||
        this.$route.params.app_id === '125' ||
        this.$route.params.app_id === '126' ||
        this.$route.params.app_id === '129' ||
        this.$route.params.app_id === '96') {
        return false
      } else {
        return true
      }
    },
    filteredRuns() {
      let self = this
      return self.runs.filter(item => self.active_status.indexOf(item.status) !== -1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Workspace.vue